import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClientJS } from 'clientjs';
import { AppConstants } from 'src/app/commons/app-constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = AppConstants.API_URL;
  fingerprint: any;
  constructor(private http: HttpClient) {
    const client = new ClientJS();
    this.fingerprint = client.getFingerprint();
  }

  // Store the token in localStorage after login

  // Example of making a request with JWT
  

  fetchTokenFromBackend(): Observable<any> {
    return this.http.get(`${this.apiUrl}/auth/token`, { withCredentials: true });
  }

  /** platform "mobile" = this confirm page belongs to a PHONE social login that opened it in the system browser. */
  logoutAllOtherDevices(platform?: string | null): Observable<any> {
    const headers = new HttpHeaders().set('deviceId', this.fingerprint.toString());
    const flag = platform === 'mobile' ? '?platform=mobile' : '';

    return this.http.post(
      `${this.apiUrl}api/v1/login/confirm-logout-other-devices${flag}`,
      {}, // You can pass an empty object or the actual body if needed
      { headers: headers, withCredentials: true } // Correctly include withCredentials here
    );
  }

  /** Describes the OTHER already-active session (device/location) for a pending device-mismatch
   *  login, so the confirmation dialog can show which device is about to be logged out before
   *  the user decides. All fields null when no info is available. */
  getPendingSessionDeviceInfo(platform?: string | null): Observable<{ device: string | null; location: string | null; lastActiveAtEpochMillis: number | null }> {
    const flag = platform === 'mobile' ? '?platform=mobile' : '';
    return this.http.get<{ device: string | null; location: string | null; lastActiveAtEpochMillis: number | null }>(
      `${this.apiUrl}api/v1/login/pending-session-device-info${flag}`,
      { withCredentials: true }
    );
  }

  getProgress() {
    return this.http.get(`${AppConstants.API_URL}api/v1/progress`, { withCredentials: true })

  }
}
